import { Signage, labOptions, signageRebootSystem } from '../Signage';
import { Log } from '../AuxillaryService/Log';
import { LocalCache } from '../Cache/LocalCache';
import { $ } from '../../vendor/jquery';

/**
 * @class
 * @hideconstructor
 * @todo document this
 */
var IndexedDb = {};

/**
 * @type {number}
 * @todo document this
 */
IndexedDb._testLocalCacheTimeout = 5000;

/**
 *
 * @todo document this
 */
IndexedDb.testLocalCacheWrite = function () {
    var jqDeferred = $.Deferred();
    var testData = {
        cache_id: '/test/write/read',
        url: 'http://example.com',
        content: {
            message: 'This is only a test',
            added: Date.now(),
        },
    };

    Signage.browserStorageEstimate().always(function (result) {
        var errorData = {};

        if (typeof result.usage !== 'undefined' && typeof result.quota !== 'undefined') {
            errorData.storageEstimate = {
                usage: result.usage,
                quota: result.quota,
            };
        } else if (result instanceof Error) {
            Log.Error(result.toString(), null, __fileline, { error: result });
        }

        // attempt to save to database
        LocalCache.save(testData.url, testData.content, testData.cache_id).fail(function (
            message,
            event
        ) {
            errorData.message = message;
            errorData.event = event;
            jqDeferred.reject(new IndexedDbError('SAVE_FAILED', errorData));
        });

        // wait a while before attempting to read from the database
        setTimeout(
            function () {
                // attempt to read from the database
                LocalCache.get(testData.cache_id)
                    .done(function (content) {
                        if (content.added == testData.content.added) {
                            jqDeferred.resolve('DATA_MATCH');
                        } else {
                            errorData.testContent = testData.content;
                            errorData.databaseContent = content;
                            jqDeferred.reject(new IndexedDbError('DATA_MISMATCH', errorData));
                        }
                    })
                    .fail(function (message, event) {
                        errorData.message = message;
                        errorData.event = event;
                        jqDeferred.reject(new IndexedDbError('READ_FAILED', errorData));
                    });
            }.bind(this),
            IndexedDb._testLocalCacheTimeout
        );

        // just in case reading is a problem too
        setTimeout(
            function () {
                jqDeferred.reject(new IndexedDbError('TIMEOUT', errorData));
            }.bind(this),
            IndexedDb._testLocalCacheTimeout + 60000
        );
    });

    return jqDeferred;
};

/**
 *
 * @todo document this
 */
IndexedDb.runDatabaseWriteTest = function () {
    var writeErrorCountKey = 'data__database_multiple_write_error_count';

    return IndexedDb.testLocalCacheWrite()
        .done(function (message) {
            Log.Info(
                'Successful database write test',
                'SIGNAGE_DATABASE_WRITE_TEST_SUCCESS',
                __fileline,
                { message: message }
            );
            Signage.platform.deleteNamedValue(writeErrorCountKey);
        })
        .fail(function (error) {
            Log.Error(error.toString(), 'SIGNAGE_DATABASE_WRITE_TEST_FAILURE', __fileline, error);
            Signage.platform.getNamedValue(writeErrorCountKey, '0').then(function (errorCount) {
                errorCount = parseInt(errorCount) + 1;
                Signage.platform.setNamedValue(writeErrorCountKey, errorCount);

                if (errorCount > 1) {
                    Log.Error(
                        error.toString(),
                        'SIGNAGE_DATABASE_WRITE_TEST_MULTIPLE_FAILURES',
                        __fileline,
                        { errorCount: errorCount }
                    );
                } else if (labOptions.instance.get('clearBrowserCacheOnIndexedDbWriteFailure')) {
                    Log.Info('Reboot and clear browser cache', null, __fileline);
                    try {
                        Signage.platform
                            .clearBrowserCacheOnReboot()
                            .done(function () {
                                void signageRebootSystem();
                            })
                            .fail(function (failError) {
                                Log.Error(failError.toString(), null, __fileline);
                            });
                    } catch (e) {
                        Log.Error(e.toString(), null, __fileline);
                    }
                }
            });
        });
};

/**
 * @class
 * @param {string} message
 * @param {Object} [data]
 * @augments Error
 */
function IndexedDbError(message, data) {
    this.name = 'IndexedDbError';
    this.message = message;
    this.stack = new Error().stack;
    this.data = data;
}
IndexedDbError.prototype = Object.create(Error.prototype);
IndexedDbError.prototype.constructor = IndexedDbError;
/**
 * @type {Object}
 */
IndexedDbError.prototype.data = undefined;

export { IndexedDb };
